import BaseComponent from "../../../baseComponent.js";

export default class TableFieldList extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      fields: this.props.fields
    }
  }
  handleChange(index) {
    return (e) =>  {
      this.state.fields[index].activated = !this.state.fields[index].activated;
      this.setState({
        fields: this.state.fields
      });
      this.props.onLegendChange("columns", this.state.fields);
    }
  }

  render () {
    let fields = [];
    for (let i = 0; i < this.state.fields.length; i++) {
      if (this.state.fields[i].fieldId != null) {
        fields.push(<div className="preview-field-list__field" key={i} data-index={i}>
          <input type="checkbox" checked={this.state.fields[i].activated} onChange={this.handleChange(i)}/>
          <span>{this.state.fields[i].name}</span>
        </div>);
      }
    }
    return (
      <div className="preview-field-list">
        <div className="preview-field-list__title">Select Fields</div>
        {fields}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/add-widget/widgets/tableFieldList.jsx